import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
100%{
    background-position: -100% 0;
}
`;

/**
 * A size as CSS. Numbers (and numeric strings like "423") get the default
 * unit; anything that already carries one ("40px", "60%", "2rem") is used as
 * given. Callers pass both forms, and adding a unit to a value that had one
 * ("40pxpx") made the browser drop the rule, so the bar collapsed to nothing.
 */
const size = (value, unit) => {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value === 'number' || /^-?\d+(\.\d+)?$/.test(String(value).trim())) return `${value}${unit}`;
  return String(value);
};

/** Fluid between 390px and 1440px viewports, only when a numeric minimum is given. */
const fluid = (value, min, unit) =>
  typeof min === 'number' && typeof value === 'number'
    ? `calc(${min}${unit} + (${value} - ${min}) * (100vw - 390px) / (1440 - 390))`
    : size(value, unit);

export const StyledSkeleton = styled.div`
  background-image: linear-gradient(
    120deg,
    var(--hd-skeleton-base) 50%,
    var(--hd-skeleton-highlight) 60%,
    var(--hd-skeleton-highlight) 61%,
    var(--hd-skeleton-base) 70%
  );
  background-size: 200%;
  background-position: 100% 0;
  animation: ${fadeIn} 1s linear infinite;
  max-width: 100%;
  width: ${({ $width, $resp }) => size($width, $resp ? 'px' : '%')};
  height: ${({ $height }) => size($height, 'px')};
  margin: ${({ $margin }) => $margin || '0'};
  border-radius: ${({ $circle, $radius }) => ($circle ? '50%' : $radius || '5px')};

  @media screen and (max-width: 1440px) {
    width: ${({ $width, $minWidth, $resp }) => fluid($width, $minWidth, $resp ? 'px' : '%')};
    height: ${({ $height, $minHeight }) => fluid($height, $minHeight, 'px')};
  }
`;
